var exports = {
  "R": "xaee3c4fa--530cc5--banner-wrapper",
};

module.exports = exports;
